module.exports = __webpack_public_path__ + "img/reverse.c8ace93d.png";